import { Component } from '@angular/core';

@Component({
  selector: 'app-users-icon',
  imports: [],
  templateUrl: './users-icon.html',
  styleUrl: './users-icon.css'
})
export class UsersIcon {

}
